/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Validation optionnelle ou obligatoire pour un courtier habilité au tunnel.
 * @export
 * @interface SetCourtierValidationOptionnelleCommand
 */
export interface SetCourtierValidationOptionnelleCommand {
    /**
     * 
     * @type {boolean}
     * @memberof SetCourtierValidationOptionnelleCommand
     */
    validationOptionnelle: boolean;
}

/**
 * Check if a given object implements the SetCourtierValidationOptionnelleCommand interface.
 */
export function instanceOfSetCourtierValidationOptionnelleCommand(value: object): value is SetCourtierValidationOptionnelleCommand {
    if (!('validationOptionnelle' in value) || value['validationOptionnelle'] === undefined) return false;
    return true;
}

export function SetCourtierValidationOptionnelleCommandFromJSON(json: any): SetCourtierValidationOptionnelleCommand {
    return SetCourtierValidationOptionnelleCommandFromJSONTyped(json, false);
}

export function SetCourtierValidationOptionnelleCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetCourtierValidationOptionnelleCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'validationOptionnelle': json['validationOptionnelle'],
    };
}

export function SetCourtierValidationOptionnelleCommandToJSON(json: any): SetCourtierValidationOptionnelleCommand {
    return SetCourtierValidationOptionnelleCommandToJSONTyped(json, false);
}

export function SetCourtierValidationOptionnelleCommandToJSONTyped(value?: SetCourtierValidationOptionnelleCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'validationOptionnelle': value['validationOptionnelle'],
    };
}

